import { getType } from 'typesafe-actions';
import { actions } from '..';
import { AgentStatistic } from '../../model';
import { Actions, StoreState } from '../types';

type StatsById =  Record<string, AgentStatistic | null | undefined>

export default function agentStats(state: StatsById = {}, action: Actions): StatsById {
  switch (action.type) {
    case getType(actions.loadAgentStats): {
      return {
        ...state,
        [action.payload.agentId]: action.payload.stats,
      }
    }
  }

  return state
}

function getRoot(state: StoreState) { return state.agentStats }

export function selectAgentStats(state: StoreState, agentId: string) {
  return getRoot(state)[agentId]
}
